import Swiper, { Navigation, Pagination, Autoplay, Thumbs, EffectFade, Controller, Mousewheel, Parallax } from 'swiper';

export default (() => {
  // Related Slider
  $('.related-wrapper').each(function() {
    const swiper = new Swiper('.carousel', {
      modules: [Navigation, Pagination, Controller],
      spaceBetween: 15,
      slidesPerView: 1.5,
      freeMode: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      centerInsufficientSlides: true,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });

  // Slider block
  $('.thor-products-slider').each(function() {
    const swiper = new Swiper('.carousel', {
      modules: [Navigation, Pagination, Controller],
      spaceBetween: 15,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });
  });

  $('.thor-flexible-gallery').each(function () {
    const slider = $(this).find('.slider')

    const mySwiper = new Swiper(slider.get(0), {
      modules: [Navigation, Pagination, Controller, Mousewheel],
      slidesPerView: 1.15,
      spaceBetween: 15,
      slidesOffsetBefore: 30,
      centeredSlidesBounds: true,
      watchOverflow: true,
      mousewheel: {
        eventsTarget: '.thor-flexible-gallery',
        sensitivity: 0.75,
        releaseOnEdges: true,
        // thresholdDelta: 5000,
        // thresholdTime: 6000,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesOffsetBefore: 0,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 60,
          slidesPerGroup: 3,
        },
      },
    })
  })

})();


// WEBPACK FOOTER //
// ./scripts/gutenberg/blocks/slider-block.js